import React from "react";
import { StyledHeader } from "./HeaderStyles";
import Controls from "./Controls/Controls";

export default function Header({ setHelp }) {
  return (
    <StyledHeader>
      <Controls setHelp={setHelp} />
    </StyledHeader>
  );
}
